import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "announcement-icon",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  fill: "currentColor"
}
const _hoisted_3 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  fill: "currentColor"
}
const _hoisted_4 = { class: "announcement-body" }
const _hoisted_5 = {
  key: 0,
  class: "announcement-text"
}
const _hoisted_6 = {
  key: 1,
  class: "announcement-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "toast-fade" }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["announcement-toast", `severity-${_ctx.severity}`]),
            style: _normalizeStyle({ top: _ctx.navbarOffset + 'px' }),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleExpanded && _ctx.toggleExpanded(...args)))
          }, [
            _createElementVNode("span", _hoisted_1, [
              (_ctx.severity === 'info')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("path", { d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("path", { d: "M12 2 1 21h22L12 2zm1 15h-2v-2h2v2zm0-4h-2v-4h2v4z" }, null, -1)
                  ]))]))
            ]),
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.isExpanded)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.primaryMessage.text), 1))
                : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedMessages, (msg, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(msg.text), 1))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("button", {
              class: "announcement-close",
              "aria-label": "Dismiss announcements",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)), ["stop"]))
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                width: "18",
                height: "18",
                fill: "currentColor"
              }, [
                _createElementVNode("path", { d: "M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z" })
              ], -1)
            ]))])
          ], 6))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}